import { put, call } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { FetchCartItemParam, fetchCartItemAction } from '@app/react/action/fetchCartItem';
import { api } from '@app/react/common/api';
import type { GetResponseCartItemData } from '@app/react/const/type';
import { safe } from '@app/react/saga/common/safe';

const fetchCartAPI = (
    cartId: number,
): Promise<GetResponseCartItemData> => (
    api.orderMadeFunctionGetCartitemDataGet({ cartitemId: cartId })
);

export function* fetchCartItemSaga(action: Action<FetchCartItemParam>): Generator {
    const { cartId } = action.payload;

    type RT = { result: GetResponseCartItemData, error: Response };
    const { result, error }: RT = yield safe(call(fetchCartAPI, cartId));

    if (error !== null) {
        console.error('[saga] fetchCartItemSaga error:', error);
        yield put(
            fetchCartItemAction.failed({
                params: action.payload,
                error: {
                    status: error.status,
                    statusText: error.statusText,
                },
            }),
        );
        return;
    }

    const { cartitemData: { id, items } } = result;
    yield put(
        fetchCartItemAction.done({
            params: action.payload,
            result: {
                cartId: id,
                designSet: items,
            },
        }),
    );
}
